module.exports = __webpack_public_path__ + "img/sign_position_seal.6ebf7f8b.png";